// Геометрия слоя-картинки после замены изображения (re-upload):
// держим прежнюю физическую ширину, высоту пересчитываем по аспекту нового
// изображения, crop — полный кадр. Единицы width/height — px холста, как у ноды.
export function replacedImageGeom(prevWidthPx, img) {
  const iw = img.width || 1
  const ih = img.height || 1
  const width = Math.abs(prevWidthPx)
  const height = width * (ih / iw)
  return { width, height, crop: { x: 0, y: 0, width: iw, height: ih } }
}
